/**
 * @generated SignedSource<<67c2ed85bacae5149b9f1c33b91c32a0>>
 * @relayHash f9d886eda0f51ddda1ce80a1ec8353b0
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4bd4276b771ccb47f32ba33697f56ec093b58741a5a012d5a5496f7369fb5c2d

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventScreenNewQuery$variables = {
  slug: string;
};
export type EventScreenNewQuery$data = {
  readonly event: {
    readonly coverPhoto: {
      readonly colorPalette: any | null | undefined;
    } | null | undefined;
    readonly owner: {
      readonly __typename: "Guild";
      readonly primaryPhoto: {
        readonly colorPalette: any | null | undefined;
      } | null | undefined;
    } | {
      readonly __typename: "User";
      readonly primaryPhoto: {
        readonly colorPalette: any | null | undefined;
      } | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"EventMetadata_event" | "EventScreenNewDesktop_event" | "EventScreenNewMobile_event">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenNewDesktop_query" | "EventScreenNewMobile_query">;
};
export type EventScreenNewQuery = {
  response: EventScreenNewQuery$data;
  variables: EventScreenNewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorPalette",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "primaryPhoto",
    "plural": false,
    "selections": (v3/*: any*/),
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": "seoUrl",
  "args": [
    {
      "kind": "Literal",
      "name": "transform",
      "value": {
        "dpr": 1,
        "fit": "contain",
        "h": 500,
        "w": 500
      }
    }
  ],
  "kind": "ScalarField",
  "name": "transformUrl",
  "storageKey": "transformUrl(transform:{\"dpr\":1,\"fit\":\"contain\",\"h\":500,\"w\":500})"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v9 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v10 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v11 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v12 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v9/*: any*/),
        (v10/*: any*/),
        {
          "kind": "Literal",
          "name": "fo",
          "value": "face"
        },
        (v11/*: any*/),
        (v12/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "transformUrl",
  "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"face\",\"h\":100,\"w\":100})"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v9/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "defaultAvatarUrl",
  "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"h\":100,\"w\":100})"
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyUrl",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "addressLine1",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "addressLine2",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateProvinceRegionCode",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipPostalCode",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "geojson",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterFirstName",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterLastName",
  "storageKey": null
},
v33 = [
  (v17/*: any*/),
  (v18/*: any*/),
  (v8/*: any*/),
  (v19/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "primaryPhoto",
    "plural": false,
    "selections": [
      (v16/*: any*/),
      (v6/*: any*/)
    ],
    "storageKey": null
  },
  (v20/*: any*/),
  (v6/*: any*/)
],
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v36 = [
  (v35/*: any*/)
],
v37 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "width",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "height",
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "transform",
        "value": {
          "dpr": 3,
          "fit": "contain",
          "fo": "left",
          "h": 80,
          "w": 150
        }
      }
    ],
    "kind": "ScalarField",
    "name": "transformUrl",
    "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"contain\",\"fo\":\"left\",\"h\":80,\"w\":150})"
  },
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventScreenNewQuery",
    "selections": [
      {
        "alias": "event",
        "args": (v1/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventBySlug",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "coverPhoto",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "Guild",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "User",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventMetadata_event"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventScreenNewDesktop_event"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventScreenNewMobile_event"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "EventScreenNewDesktop_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "EventScreenNewMobile_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventScreenNewQuery",
    "selections": [
      {
        "alias": "event",
        "args": (v1/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventBySlug",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "coverPhoto",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/),
              {
                "alias": "seoUrl",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "transform",
                    "value": {
                      "dpr": 1,
                      "fit": "cover",
                      "h": 630,
                      "w": 1200
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "transformUrl",
                "storageKey": "transformUrl(transform:{\"dpr\":1,\"fit\":\"cover\",\"h\":630,\"w\":1200})"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "transform",
                    "value": {
                      "dpr": 3,
                      "w": 368
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "transformUrl",
                "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":368})"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "primaryPhoto",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "fields": [
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/)
                            ],
                            "kind": "ObjectValue",
                            "name": "transform"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "transformUrl",
                        "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
                      }
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GuildMembership",
                    "kind": "LinkedField",
                    "name": "myMembership",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "membershipLevel",
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sponsorshipDisplay",
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "type": "Guild",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "primaryPhoto",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isMe",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "type": "User",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeZone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasExternalUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasVenue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Venue",
            "kind": "LinkedField",
            "name": "seoVenue",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Address",
                "kind": "LinkedField",
                "name": "address",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v6/*: any*/),
                  (v29/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": "seoPresentations",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10
              }
            ],
            "concreteType": "PresentationsConnection",
            "kind": "LinkedField",
            "name": "presentations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PresentationsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Presentation",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v30/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "presenter",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "primaryPhoto",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "presentations(first:10)"
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "visibility",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EventAttendee",
            "kind": "LinkedField",
            "name": "myAttendance",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Venue",
            "kind": "LinkedField",
            "name": "venue",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entryInstructions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Address",
                "kind": "LinkedField",
                "name": "address",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formattedAddress",
                    "storageKey": null
                  },
                  (v29/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PresentationsConnection",
            "kind": "LinkedField",
            "name": "presentations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PresentationsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Presentation",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v21/*: any*/),
                      (v30/*: any*/),
                      (v22/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "transform",
                            "value": {
                              "dpr": 3,
                              "h": 48,
                              "w": 48
                            }
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "guestPresenterAvatarUrl",
                        "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"h\":48,\"w\":48})"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "presenter",
                        "plural": false,
                        "selections": (v33/*: any*/),
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v34/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "status": {
                    "in": [
                      "ATTENDING_IN_PERSON",
                      "ATTENDING_VIRTUAL",
                      "WAITING_IN_PERSON",
                      "WAITING_VIRTUAL"
                    ]
                  }
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 8
              }
            ],
            "concreteType": "EventAttendeesConnection",
            "kind": "LinkedField",
            "name": "eventAttendeesByRelevance",
            "plural": false,
            "selections": [
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EventAttendeesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventAttendee",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": (v33/*: any*/),
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v34/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:8)"
          },
          {
            "alias": "attendingCount",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "status": {
                    "in": [
                      "ATTENDING_IN_PERSON",
                      "ATTENDING_VIRTUAL"
                    ]
                  }
                }
              }
            ],
            "concreteType": "EventAttendeesConnection",
            "kind": "LinkedField",
            "name": "eventAttendees",
            "plural": false,
            "selections": (v36/*: any*/),
            "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
          },
          {
            "alias": "waitingCount",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "status": {
                    "in": [
                      "WAITING_IN_PERSON",
                      "WAITING_VIRTUAL"
                    ]
                  }
                }
              }
            ],
            "concreteType": "EventAttendeesConnection",
            "kind": "LinkedField",
            "name": "eventAttendees",
            "plural": false,
            "selections": (v36/*: any*/),
            "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "SORT_ORDER_ASC",
                  "CREATED_AT_ASC"
                ]
              }
            ],
            "concreteType": "EventTicketingTiersConnection",
            "kind": "LinkedField",
            "name": "eventTicketingTiers",
            "plural": false,
            "selections": (v36/*: any*/),
            "storageKey": "eventTicketingTiers(orderBy:[\"SORT_ORDER_ASC\",\"CREATED_AT_ASC\"])"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Form",
            "kind": "LinkedField",
            "name": "attendeeForm",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 2
          }
        ],
        "concreteType": "GuildSponsorshipsConnection",
        "kind": "LinkedField",
        "name": "sponsorships",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GuildSponsorshipsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GuildSponsorship",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "webUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkText",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "lightModeImage",
                    "plural": false,
                    "selections": (v37/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "darkModeImage",
                    "plural": false,
                    "selections": (v37/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Guild",
                    "kind": "LinkedField",
                    "name": "guild",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v34/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "sponsorships(first:2)"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "authorizationLevel",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "4bd4276b771ccb47f32ba33697f56ec093b58741a5a012d5a5496f7369fb5c2d",
    "metadata": {},
    "name": "EventScreenNewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c30fda784974a37f40b1d498a162d7cf";

export default node;
